import Vue from "vue";
import App from "./App";
import router from "./router";
import axios from "axios";

Vue.prototype.$axios = axios;
Vue.prototype.$axiosHeader = {
	"Authorization" : "Bearer 4P7wxWRe6YSXyJuQprzpyj9aD2ckYLEpjcwhVH3eLuzEl2ja-wa3jH4_Km5i0PCAiRikPGvrT0qVXfg59ksAxrs80uFYYDLmOFu6Wa9fk5mshEfb-uLjwCfvwRnDGaIiyp-Hxovje8JwhWzCIqMenDK4GwN4xQObhanmYN1ecvkGsx8-qBh16bRych4d3PBIJuBn2xHk"
 };
Vue.config.productionTip = false;

new Vue({
	el : "#app",
	router,
	components : { App },
	template : "<App/>"
});

router.beforeEach(function(to, from, next){
	var $ = router.app.$children[0];
	
	$.introShow = true;
	$.navHide();
	window.scrollTo(0, 0);
	
	next();
});

if(/MSIE \d|Trident.*rv:/.test(navigator.userAgent)){
	window.location = "microsoft-edge:" + window.location;

	setTimeout(function(){
		window.location = "https://go.microsoft.com/fwlink/?linkid=2135547";
	}, 10);
}


// WEBPACK FOOTER //
// ./src/main.js